import { Component, OnInit } from '@angular/core';
import { EventOriginEnum, NavigateToEnum } from '@app/core/enums/analytics/analytics-value.enum';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { IRelatedAsset, RelatedAsset } from '@app/core/model/entities/asset/asset';
import { Document } from '@app/core/model/entities/document/document';
import {
  AssetFieldBuilderComponent
} from '@app/shared/components/fields/entity-field-builder/asset-field-builder/asset-field-builder.component';

@Component({
    selector: 'document-assets-field-builder',
    templateUrl: './document-assets-field-builder.component.html',
    standalone: false
})
export class DocumentAssetsFieldBuilderComponent extends AssetFieldBuilderComponent implements OnInit {
  protected isSingleRelatedAsset = (this.entity as Document).relatedAssets.length <= 1;

  /**
   * Retrieves the field's value from the FormStateService.
   */
  public override getFieldValue(): IRelatedAsset[] {
    return super.getFieldValue();
  }

  /**
   * Navigate to the Dashboard of the related Asset
   */
  public override async navigateToEntitySheet(): Promise<void> {
    const assetId = (this.entity as Document).relatedAssets.first().id;
    await this.navigateToAssetDashboardByAssetId(assetId);
  };


  /**
   * Set the init value of the asset according to the init value of the field.
   */
  protected setEntityInitValue(): void {
    if (this.entityInitValue || !this.fieldInitValue) return;

    this.entityInitValue = this.fieldInitValue.length > 0 ?
      this.fieldInitValue.map((asset: IRelatedAsset) => new RelatedAsset(asset)) : null;
  }

  /**
   * Navigate to the Dashboard of the related Asset
   * @param assetId
   */
  public async navigateToAssetDashboardByAssetId(assetId: string): Promise<void> {
    this.analyticsService.trackNavigationEvent(
      EventOriginEnum.FIELD_CLICK,
      NavigateToEnum.SHEET,
      EntityTypeEnum.ASSET,
      assetId
    );
    await this.assetsService.navigateToAssetSheet(assetId, 'dashboard');
  }
}
